/*
 * Lightbox Tiloa — visionneuse des photos jointes aux avis.
 *
 * Aucune photo d'avis ne doit ouvrir un onglet ni quitter la boutique :
 * les miniatures sont des <button data-lightbox>, jamais des <a href>.
 *
 * S'appuie sur <dialog> natif : focus piégé, retour du focus sur la
 * miniature à la fermeture et touche Échap gérés par le navigateur.
 * La grande image n'est téléchargée qu'à l'ouverture.
 */
(function () {
  'use strict';

  var dlg = null;
  var img = null;
  var legende = null;
  var prev = null;
  var next = null;
  var compteur = null;
  var groupe = [];
  var index = 0;
  var scrollY = 0;

  function construire() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'tiloa-lb';
    dlg.setAttribute('aria-label', 'Photo jointe à un avis client');
    dlg.innerHTML =
      '<div class="tiloa-lb__inner">' +
      '<figure class="tiloa-lb__figure">' +
      '<img class="tiloa-lb__img" alt="">' +
      '<figcaption class="tiloa-lb__caption"></figcaption>' +
      '</figure>' +
      '<button type="button" class="tiloa-lb__close" aria-label="Fermer la photo">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="tiloa-lb__nav tiloa-lb__nav--prev" aria-label="Photo précédente">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button type="button" class="tiloa-lb__nav tiloa-lb__nav--next" aria-label="Photo suivante">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<p class="tiloa-lb__count" aria-live="polite"></p>' +
      '</div>';
    document.body.appendChild(dlg);

    img = dlg.querySelector('.tiloa-lb__img');
    legende = dlg.querySelector('.tiloa-lb__caption');
    prev = dlg.querySelector('.tiloa-lb__nav--prev');
    next = dlg.querySelector('.tiloa-lb__nav--next');
    compteur = dlg.querySelector('.tiloa-lb__count');

    dlg.querySelector('.tiloa-lb__close').addEventListener('click', fermer);
    prev.addEventListener('click', function () { aller(-1); });
    next.addEventListener('click', function () { aller(1); });

    // Clic sur le fond : on ferme. Clic sur l'image : on ne ferme pas.
    dlg.addEventListener('click', function (e) {
      if (!e.target.closest('.tiloa-lb__figure, .tiloa-lb__close, .tiloa-lb__nav')) fermer();
    });

    dlg.addEventListener('close', liberer);
    dlg.addEventListener('cancel', function () { liberer(); });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); aller(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(1); }
    });

    // Balayage horizontal au doigt.
    var x0 = null;
    dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) aller(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
  }

  function afficher() {
    var btn = groupe[index];
    if (!btn) return;
    img.src = btn.dataset.full || btn.querySelector('img').src;
    img.alt = btn.dataset.alt || '';
    legende.textContent = btn.dataset.caption || '';
    legende.hidden = !btn.dataset.caption;
    var multi = groupe.length > 1;
    prev.hidden = !multi;
    next.hidden = !multi;
    compteur.hidden = !multi;
    if (multi) compteur.textContent = index + 1 + ' / ' + groupe.length;
  }

  function aller(pas) {
    if (groupe.length < 2) return;
    index = (index + pas + groupe.length) % groupe.length;
    afficher();
  }

  function ouvrir(btn) {
    construire();
    var conteneur = btn.closest('[data-lightbox-group]');
    groupe = conteneur
      ? Array.prototype.slice.call(conteneur.querySelectorAll('[data-lightbox]'))
      : [btn];
    index = Math.max(0, groupe.indexOf(btn));
    afficher();

    // Le défilement de la page est bloqué sans perdre la position.
    scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';

    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  }

  function fermer() {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
    // On ne dépend pas seulement de l'événement « close » : il n'est pas
    // déclenché sur tous les chemins de fermeture. liberer() est idempotent.
    liberer();
  }

  function liberer() {
    document.body.style.overflow = '';
    if (window.scrollY !== scrollY) window.scrollTo(0, scrollY);
    if (img) img.removeAttribute('src');
  }

  // Délégation : fonctionne aussi pour les avis ajoutés après coup par Judge.me.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lightbox]');
    if (!btn) return;
    e.preventDefault();
    ouvrir(btn);
  });
})();
